const airportTabsMets = {
  "metars": {
    "key": "metars",
    "label": "METARs"
  },
  "tafs": {
    "key": "tafs",
    "label": "TAF"
  },
  "forecastDiscussion": {
    "key": "fcstdiscussion",
    "label": "Forecast Discussion"
  },
  "radar": {
    "key": "radar",
    "label": "Radar"
  },
  "skewT": {
    "key": "skew-t",
    "label": "Skew-T"
  },
  "meteogram": {
    "key": "meteogram",
    "label": "Meteogram"
  }
};

export default {
  observationsTabs: [
    {
      key: airportTabsMets.metars.key,
      label: airportTabsMets.metars.label,
      icon: 'binoculars',
      goToView: 'dashboard',
      fontawesome: true,
    },
    {
      key: airportTabsMets.radar.key,
      label: airportTabsMets.radar.label,
      icon: 'binoculars',
      goToView: 'dashboard',
      fontawesome: true,
    },
  ],
  forecastTabs: [
    {
      key: 'meteogram',
      label: 'Meteogram',
      icon: 'trendingUp',
      fontawesome: false,
      goToView: 'dashboard',
    },
    {
      key: 'weather',
      label: '7-Day',
      icon: 'trendingUp',
      fontawesome: false,
      goToView: 'weather',
    },
    {
      key: airportTabsMets.tafs.key,
      label: airportTabsMets.tafs.label,
      icon: 'trendingUp',
      goToView: 'dashboard',
      fontawesome: false,
    },
    {
      key: airportTabsMets.forecastDiscussion.key,
      label: airportTabsMets.forecastDiscussion.label,
      goToView: 'dashboard',
      icon: 'trendingUp',
      fontawesome: false,
    },
    {
      key: airportTabsMets.skewT.key,
      label: airportTabsMets.skewT.label,
      icon: 'trendingUp',
      goToView: 'dashboard',
      fontawesome: false,
    },
  ],
};
